<div class="mr-form">

  <div class="mr-encabezado">
    <div>
      <h2>{{ edicion ? 'Editar activo' : 'Nuevo activo' }}</h2>
      <p class="mr-sub">
        Matriz de Riesgos IA &middot; FOS-005 IA-001
        <span *ngIf="activo.consecutivo"> &middot; Folio {{ activo.consecutivo }}</span>
      </p>
    </div>
    <div class="mr-botones">
      <span class="mr-solo-lectura" *ngIf="!puedeEditar">Sólo lectura</span>
      <button mat-stroked-button (click)="regresar()">{{ embebido ? 'Cerrar' : 'Regresar' }}</button>
      <button mat-flat-button color="primary" *ngIf="puedeEditar" (click)="guardar()" [disabled]="guardando">
        {{ guardando ? 'Guardando…' : (edicion ? 'Actualizar' : 'Guardar') }}
      </button>
    </div>
  </div>

  <div class="mr-cargando" *ngIf="cargando">Cargando…</div>

  <ng-container *ngIf="!cargando">

    <!-- 1. Identificación -->
    <section class="mr-seccion">
      <h3>1. Identificación del activo</h3>

      <div class="mr-grid">
        <mat-form-field appearance="outline" class="ancho-2">
          <mat-label>Nombre del activo <span class="oblig">*</span></mat-label>
          <input aria-label="Nombre del activo *" matInput [maxlength]="lim.activo.nombreActivo" [(ngModel)]="activo.nombreActivo" name="nombreActivo" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Tipo de activo</mat-label>
          <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="activo.tipoActivo" name="tipoActivo">
            <mat-option value="Software">Software</mat-option>
            <mat-option value="Hardware">Hardware</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Folio del inventario IA</mat-label>
          <input aria-label="Folio del inventario IA" matInput type="number" [(ngModel)]="activo.idInventarioIa" name="idInventarioIa" />
          <mat-hint *ngIf="activo.inventarioConsecutivo">
            {{ activo.inventarioConsecutivo }} — {{ activo.inventarioNombre }}
          </mat-hint>
          <mat-hint *ngIf="!activo.inventarioConsecutivo">
            Se captura el id del activo inventariado.
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Fecha de identificación</mat-label>
          <input aria-label="Fecha de identificación" matInput [matDatepicker]="dpIdent" [(ngModel)]="activo.fechaIdentificacion"
                 name="fechaIdentificacion" />
          <mat-datepicker-toggle matSuffix [for]="dpIdent"></mat-datepicker-toggle>
          <mat-datepicker panelClass="matriz-ia-datepicker-panel" #dpIdent></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ancho-3">
          <mat-label>Activos dependientes</mat-label>
          <textarea aria-label="Activos dependientes" matInput cdkTextareaAutosize [maxlength]="lim.activo.activosDependientes" [(ngModel)]="activo.activosDependientes"
                    name="activosDependientes"></textarea>
          <mat-hint>Otros activos de los que éste depende para funcionar.</mat-hint>
        </mat-form-field>
      </div>
    </section>

    <!-- 2. Valoración -->
    <section class="mr-seccion">
      <h3>2. Valoración del activo</h3>
      <p class="mr-nota">
        El criterio de cada nivel aparece al abrir el desplegable. El
        <strong>valor del activo</strong> es el máximo de los tres.
      </p>

      <div class="mr-grid">
        <mat-form-field appearance="outline" [title]="notas['confidencialidad']">
          <mat-label>Confidencialidad</mat-label>
          <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="activo.valConfidencialidad" name="valC">
            <mat-option *ngFor="let v of valoracionPor('CONFIDENCIALIDAD')" [value]="v.nivel"
                        [matTooltip]="v.descripcion">
              {{ v.nivel }} — {{ v.etiqueta }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" [title]="notas['integridad']">
          <mat-label>Integridad</mat-label>
          <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="activo.valIntegridad" name="valI">
            <mat-option *ngFor="let v of valoracionPor('INTEGRIDAD')" [value]="v.nivel"
                        [matTooltip]="v.descripcion">
              {{ v.nivel }} — {{ v.etiqueta }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" [title]="notas['disponibilidad']">
          <mat-label>Disponibilidad</mat-label>
          <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="activo.valDisponibilidad" name="valD">
            <mat-option *ngFor="let v of valoracionPor('DISPONIBILIDAD')" [value]="v.nivel"
                        [matTooltip]="v.descripcion">
              {{ v.nivel }} — {{ v.etiqueta }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="mr-calculado">
          <span class="etq">Valor del activo</span>
          <span class="val">{{ valorActivoPreview !== null ? valorActivoPreview : '—' }}</span>
        </div>
      </div>

      <mat-form-field appearance="outline" class="ancho-total">
        <mat-label>Justificación de la valoración</mat-label>
        <textarea aria-label="Justificación de la valoración" matInput cdkTextareaAutosize [maxlength]="lim.activo.justificacionValoracion" [(ngModel)]="activo.justificacionValoracion"
                  name="justificacionValoracion"></textarea>
        <mat-hint>Por qué se valoró así. Si se usa criterio de peor escenario, decirlo aquí.</mat-hint>
      </mat-form-field>
    </section>

    <!-- 3. Amenazas -->
    <section class="mr-seccion">
      <div class="mr-seccion-head">
        <h3>3. Amenazas, vulnerabilidades y plan de acción</h3>
        <button mat-stroked-button (click)="agregarAmenaza()">Agregar amenaza</button>
      </div>

      <p class="mr-vacio" *ngIf="!activo.amenazas || activo.amenazas.length === 0">
        Sin amenazas capturadas. El riesgo no se puede calcular hasta que haya al menos una.
      </p>

      <div class="mr-amenaza" *ngFor="let am of activo.amenazas; let i = index">
        <div class="mr-amenaza-head">
          <span class="mr-badge">Amenaza {{ i + 1 }}</span>
          <button mat-icon-button title="Quitar amenaza" (click)="quitarAmenaza(i)">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="mr-grid">
          <mat-form-field appearance="outline" class="ancho-2" [title]="notas['nombreAmenaza']">
            <mat-label>Nombre de la amenaza <span class="oblig">*</span></mat-label>
            <input aria-label="Nombre de la amenaza *" matInput [maxlength]="lim.amenaza.nombreAmenaza" [(ngModel)]="am.nombreAmenaza" [name]="'am' + i" />
          </mat-form-field>

          <mat-form-field appearance="outline" [title]="notas['probAmenaza']">
            <mat-label>Probabilidad actual</mat-label>
            <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="am.probActual" [name]="'amp' + i">
              <mat-option *ngFor="let p of probabilidadPor('AMENAZA')" [value]="p.nivel"
                          [matTooltip]="p.descripcion">
                {{ p.nivel }} — {{ p.etiqueta }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Tras plan de acción</mat-label>
            <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="am.probTrasPlan" [name]="'amt' + i">
              <mat-option *ngFor="let p of probabilidadPor('AMENAZA')" [value]="p.nivel"
                          [matTooltip]="p.descripcion">
                {{ p.nivel }} — {{ p.etiqueta }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ancho-2">
            <mat-label>Categoría del catálogo (opcional)</mat-label>
            <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="am.idCatAmenaza" [name]="'amc' + i">
              <mat-option [value]="null">Sin mapear</mat-option>
              <mat-optgroup *ngFor="let cat of categoriasAmenaza" [label]="cat">
                <mat-option *ngFor="let ca of amenazasDe(cat)" [value]="ca.idCatAmenaza">
                  {{ ca.nombre }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
            <mat-hint>Mapear al catálogo MAGERIT evita la pregunta del auditor</mat-hint>
          </mat-form-field>
        </div>

        <!-- Vulnerabilidades de esta amenaza -->
        <div class="mr-sub-bloque">
          <div class="mr-sub-head">
            <span>Vulnerabilidades de esta amenaza</span>
            <button mat-stroked-button (click)="agregarVulnerabilidad(am)">Agregar vulnerabilidad</button>
          </div>

          <p class="mr-vacio-mini" *ngIf="!am.vulnerabilidades || am.vulnerabilidades.length === 0">
            Sin vulnerabilidades. Explica <em>por qué</em> el activo permite que esta amenaza ocurra.
          </p>

          <div class="mr-vulnerabilidad" *ngFor="let vu of am.vulnerabilidades; let j = index">
            <div class="mr-vul-head">
              <span class="mr-badge sec">Vulnerabilidad {{ j + 1 }}</span>
              <button mat-icon-button title="Quitar vulnerabilidad" (click)="quitarVulnerabilidad(am, j)">
                <i class="material-icons">close</i>
              </button>
            </div>

            <div class="mr-grid">
              <mat-form-field appearance="outline" class="ancho-2" [title]="notas['vulnerabilidad']">
                <mat-label>Vulnerabilidad <span class="oblig">*</span></mat-label>
                <input aria-label="Vulnerabilidad *" matInput [maxlength]="lim.vulnerabilidad.nombreVulnerabilidad" [(ngModel)]="vu.nombreVulnerabilidad" [name]="'vu' + i + '_' + j" />
              </mat-form-field>

              <mat-form-field appearance="outline" [title]="notas['probVulnerabilidad']">
                <mat-label>Probabilidad actual</mat-label>
                <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="vu.probActual" [name]="'vup' + i + '_' + j">
                  <mat-option *ngFor="let p of probabilidadPor('VULNERABILIDAD')" [value]="p.nivel"
                              [matTooltip]="p.descripcion">
                    {{ p.nivel }} — {{ p.etiqueta }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Tras plan de acción</mat-label>
                <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="vu.probTrasPlan" [name]="'vut' + i + '_' + j">
                  <mat-option *ngFor="let p of probabilidadPor('VULNERABILIDAD')" [value]="p.nivel"
                              [matTooltip]="p.descripcion">
                    {{ p.nivel }} — {{ p.etiqueta }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Acciones de esta vulnerabilidad -->
            <div class="mr-sub-bloque nivel-3">
              <div class="mr-sub-head">
                <span>Plan de acción</span>
                <button mat-stroked-button (click)="agregarAccion(vu)">Agregar acción</button>
              </div>

              <div class="mr-accion" *ngFor="let ac of vu.acciones; let k = index">
                <div class="mr-grid">
                  <mat-form-field appearance="outline" class="ancho-3">
                    <mat-label>Acción <span class="oblig">*</span></mat-label>
                    <textarea aria-label="Acción *" matInput cdkTextareaAutosize [maxlength]="lim.accion.descripcion" [(ngModel)]="ac.descripcion"
                              [name]="'ac' + i + '_' + j + '_' + k"></textarea>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Estado</mat-label>
                    <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="ac.estado" [name]="'ace' + i + '_' + j + '_' + k">
                      <mat-option value="Programada">Programada</mat-option>
                      <mat-option value="Aplicada">Aplicada</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Responsable</mat-label>
                    <input aria-label="Responsable" matInput [maxlength]="lim.accion.responsable" [(ngModel)]="ac.responsable" [name]="'acr' + i + '_' + j + '_' + k" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" [title]="notas['prioridad']">
                    <mat-label>Prioridad</mat-label>
                    <mat-select panelClass="matriz-ia-select-panel" [(ngModel)]="ac.prioridad" [name]="'acp' + i + '_' + j + '_' + k">
                      <mat-option value="Baja">Baja</mat-option>
                      <mat-option value="Media">Media</mat-option>
                      <mat-option value="Alta">Alta</mat-option>
                      <mat-option value="Muy Alta">Muy Alta</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Fecha de ejecución</mat-label>
                    <input aria-label="Fecha de ejecución" matInput [matDatepicker]="dpAc" [(ngModel)]="ac.fechaEjecucion"
                           [name]="'acf' + i + '_' + j + '_' + k" />
                    <mat-datepicker-toggle matSuffix [for]="dpAc"></mat-datepicker-toggle>
                    <mat-datepicker panelClass="matriz-ia-datepicker-panel" #dpAc></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="ancho-2" [title]="notas['recursos']">
                    <mat-label>Recursos necesarios</mat-label>
                    <input aria-label="Recursos necesarios" matInput [maxlength]="lim.accion.recursos" [(ngModel)]="ac.recursos" [name]="'acre' + i + '_' + j + '_' + k" />
                  </mat-form-field>

                  <button mat-icon-button class="mr-quitar-accion" title="Quitar acción"
                          (click)="quitarAccion(vu, k)">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <div class="mr-pie">
      <button mat-stroked-button (click)="regresar()">{{ embebido ? 'Cerrar' : 'Regresar' }}</button>
      <button mat-flat-button color="primary" *ngIf="puedeEditar" (click)="guardar()" [disabled]="guardando">
        {{ guardando ? 'Guardando…' : (edicion ? 'Actualizar' : 'Guardar') }}
      </button>
    </div>

  </ng-container>
</div>
